var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"description",class:[
      _vm.style.description,
      _vm.showMore ? _vm.style.show : '',
      _vm.isOverflow && !_vm.showMore ? _vm.style.ellipsis : ''
    ]},[_vm._t("default")],2),_vm._v(" "),(_vm.isOverflow)?_c('span',{class:[_vm.style['show-more']],on:{"click":function($event){_vm.showMore = !_vm.showMore}}},[_vm._v(_vm._s(_vm.showMore ? _vm.$t('show_less') : _vm.$t('show_more')))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }